import * as yup from 'yup';

interface TestContextExtended {
    [key: string]: any;
  }

function currenciesValidationSchema() {
    return yup.object({
        params: yup.object().shape({
            reduceAmount: yup.mixed().test('reduceAmountTest', 'Cost must be a positive number',
            (value, testContext) => {
                const {from} = testContext as yup.TestContext & TestContextExtended
                const useCurrency = from?.[1]?.value?.tempParams?.useCurrency;
                let result = true;
                value && value.forEach((element: {currencyId: string, amount: string})  => {
                    if (useCurrency && (!(/^\d+$/.test(element.amount)) || (parseInt(element.amount) <= 0))) {
                        result = false
                    }
                })
                return result
            })
            .test('reduceAmountTest', 'Currency should be selected',
            (value, testContext) => {
                const {from} = testContext as yup.TestContext & TestContextExtended
                const useCurrency = from?.[1]?.value?.tempParams?.useCurrency;
                let result = true;
                value && value.forEach((element: {currencyId: string, amount: string})  => {
                    if (useCurrency && !element.currencyId) {
                        result = false
                    }
                })
                return result
            }),
        }),
        tempParams: yup.object().shape({
            leaderboadCurrencyNames: yup.array().of(yup.string())
                .when('enableLeaderboard', {
                    is: true,
                    then: yup.array().min(1, 'At least one currency must be selected'),
                    otherwise: yup.array().notRequired()
                }),
        }),
        leaderboard: yup.object().shape({
            expiresAt: yup.number().test(
                'expiresAt required test',
                'Expiration date is required',
                (value, testContext) => {
                    const { from } = testContext as yup.TestContext & TestContextExtended;
                    let result = true;
                    if (from[1].value.tempParams.enableLeaderboard && !value) {
                        result = false;
                    }
                    return result
                }
            )
        })
    })
}

export { currenciesValidationSchema }
